import  Message, { MessageDirection, MessageStatus, MessageType} from '../models/Message';
import { GenericResponse, TextResponse, TextLinkResponse, OptionResponse, Option, ImageResponse, CardResponse } from '../models/Conversation';

export const parseMessageText = (genResponse: GenericResponse, index:number):Message => {
    const msg:Message = {
        messageIndex: index,
        messageDirection: MessageDirection.RECEIVED,
        messageStatus: MessageStatus.RECEIVED,
        messageType: MessageType.TEXT,
        messageData: (genResponse.response as TextResponse).text
      }
    return msg;
}

export const parseMessageTextLink = (genResponse: GenericResponse, index:number):Message => {
  const msgText:string = (genResponse.response as TextResponse).text;
  const textLink:TextLinkResponse = {
    text: msgText
  }
  const msg:Message = {
      messageIndex: index,
      messageDirection: MessageDirection.RECEIVED,
      messageStatus: MessageStatus.RECEIVED,
      messageType: MessageType.TEXT_LINK,
      messageData: textLink
    }
  return msg;
}

export const parseMessageOption = (genResponse: GenericResponse, index:number):Message[] => {
    const msgList:Message[] = [];
    let msg:Message = {
        messageIndex: index,
        messageDirection: MessageDirection.RECEIVED,
        messageStatus: MessageStatus.RECEIVED,
        messageType: MessageType.TEXT,
        messageData: (genResponse.response as OptionResponse).title
      }
      msgList.push(msg);

      msg = {
        messageIndex: index+1,
        messageDirection: MessageDirection.RECEIVED,
        messageStatus: MessageStatus.RECEIVED,
        messageType: MessageType.QUICK_RESPONSE,
        messageData: (genResponse.response as OptionResponse).options
      }
      msgList.push(msg);

    return msgList;
}

export const parseMessageImage = () => {
    
}

export const parseMessageSuggestion = () => {

}

export const parseMessageCardCarousel = (genResponses: GenericResponse[], index:number, length:number, messagesLength:number):Message => {
  const msgCardList: Message[] = parseMessageCard(genResponses, index, length, messagesLength);
  const msg:Message = {
    messageIndex: messagesLength,
      messageDirection: MessageDirection.RECEIVED,
      messageStatus: MessageStatus.RECEIVED,
      messageType: MessageType.CARD_CAROUSEL,
      messageData: msgCardList
  };
  return msg;
}

export const parseMessageCard = (genResponses: GenericResponse[], index:number, length:number, messagesLength:number):Message[] => {
    const msgList:Message[] = [];
    for (let i = index; i < length*2; i=i+2) {
      const imageResponseIndex: number = i;
      const optionResponseIndex: number = i + 1;
      const title: string = (genResponses[optionResponseIndex].response as OptionResponse).title
      const description: string = (genResponses[optionResponseIndex].response as OptionResponse).description!
      const media: ImageResponse = genResponses[imageResponseIndex].response as ImageResponse
      const actions: Option[] = (genResponses[optionResponseIndex].response as OptionResponse).options
      const card: CardResponse = {
        actions: actions,
        description: description,
        media: media,
        title: title
      }
      const msg:Message = {
        messageIndex: messagesLength + 100,
        messageDirection: MessageDirection.RECEIVED,
        messageStatus: MessageStatus.RECEIVED,
        messageType: MessageType.CARD,
        messageData: card
      }
      msgList.push(msg);
      messagesLength += 1;
    }
    
    return msgList;
}
